/**
 * @generated SignedSource<<312e665795a544c676e3430c6d69a2aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItems_item$data = {
  readonly serviceId: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_item">;
  readonly " $fragmentType": "PdpRespSellerItems_item";
};
export type PdpRespSellerItems_item$key = {
  readonly " $data"?: PdpRespSellerItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItems_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItems_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "e3e19bc8297c9d7b9fb635dd7d9200e2";

export default node;
